import React from 'react';
import useUser from '../hooks/useUser';
import Servercategorymasters from '../masters/server/Categorymasters';
import Clientcategorymasters from '../masters/client/Categorymasters';

const CategoryMaster = () => {
    const { userRole } = useUser();
    // Get role from localStorage as fallback
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';
    // Render based on role
    if (roleLower === 'gspos') {
        return <Servercategorymasters />;
    } else if (roleLower === 'client') {
        return <Clientcategorymasters />;
    }
};
export default CategoryMaster;
